import axios from "axios";
import React from "react";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import { loginSliceValue } from "../../redux/reducers/loginSlice";
import { IntakeFormQuestion } from "./index.type";

const useActivatePatient = () => {
  const { userDetails } = useSelector(loginSliceValue);
  const [activatedPatientLoading, setActivatedPatientLoading] = React.useState(false);

  const activatePatient = async ({
    patientId,
    planId,
    intakeFormDetails
  }: {
    patientId: string;
    planId: string;
    intakeFormDetails:IntakeFormQuestion[] | undefined;
  }) => {
    setActivatedPatientLoading(true);

    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_BASE_URL}/rtm/patient/active?patientId=${patientId}&planId=${planId}`,
        {
          intakeForm:intakeFormDetails
        }, 
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + userDetails.token,
          }
        }
      );

      if (response?.status === 200) {
        toast.success(response.data.message);
        return response;
      }

    } catch (error) {
      toast.error("Something went wrong while updating status");
    } finally {
      setActivatedPatientLoading(false); 
    }
  };

  return { activatePatient, activatedPatientLoading };
};

export default useActivatePatient;
